// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8301 ? "ca4dcb09" : chunkId) + "-" + {"2467":"b5d6255480617456","3109":"20c03c31434323d1","8301":"d1ebf0c49ba7111a"}[chunkId] + ".js";
};